export default {
  QUEST_HELP_QUESTID: 'c-42190094-1527-431c-a4cd-3ad2d8512284',
  USER_ID: 'u-83cf4183-47ad-4ef4-b61a-e9d29a17884a',
  APIKEY: 'k-69e5d08e-38dc-465e-98f7-2da38b40fd78',
  TOKEN: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJ1LTgzY2Y0MTgzLTQ3YWQtNGVmNC1iNjFhLWU5ZDI5YTE3ODg0YSIsImlhdCI6MTc1MzYwMDM4NywiZXhwIjoxNzU2MTkyMzg3fQ.5vnOBci3EFvcptIwK9elMySGEKHTeBx1tYSFkd0uZiM',
  ENTITYID: 'e-a68c7dd2-c9d0-42ec-ad3b-99ba8c4a874b',
  PRIMARY_COLOR: '#0AB6BC'
};